import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./Components/Header";
import MainDashboard from "./Components/MainDashboard";
import "./assets/css/style.css";
import Test from "./Components/Test";
import ManageCategory from "./Components/ManageCategory";
import ProductManagement from "./Components/ProductManagement";
import CompressionCate from "./Components/CompressionCate";
import CompressionPro from "./Components/CompressionPro";
import LoginPage from './Components/LoginPage';
import ProtectedRoute from './Components/ProtectedRoute';
import AdminSubmissions from "./Components/AdminSubmissions";

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  return (
    <Router>
      <div className="App container-scroller d-flex">
      {isAuthenticated && <Header />}{/* Header includes Sidebar */}
        <div className="content-container w-100 mt-5 pt-5">
          <Routes>
          <Route path="/" element={<LoginPage setAuthenticated={setIsAuthenticated} />} />

          <Route
          path="/managecategory"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <ManageCategory />
            </ProtectedRoute>
          }
        />
         <Route
          path="/manageproduct"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <ProductManagement />
            </ProtectedRoute>
          }
        /> 
        <Route
        path="/managecompressioncategory"
        element={
          <ProtectedRoute isAuthenticated={isAuthenticated}>
            <CompressionCate />
          </ProtectedRoute>
        }
      />
      <Route
        path="/managecompressionproduct"
        element={
          <ProtectedRoute isAuthenticated={isAuthenticated}>
            <CompressionPro />
          </ProtectedRoute>
        }
      />
      <Route
        path="/mails"
        element={
      
            <AdminSubmissions />
   
        }
      />
            {/* <Route path="/managecategory" element={<ManageCategory />} />
            <Route path="/manageproduct" element={<ProductManagement />} />
            <Route path="/managecompressioncategory" element={<CompressionCate />} />
            <Route path="/managecompressionproduct" element={<CompressionPro />} /> */}


          </Routes>
        </div>
      </div>
    </Router>
  );
}

export default App;
